import React from 'react'
import { Header, List, Radio, Card, Button } from 'semantic-ui-react'
import moment from 'moment-timezone'
import { Modal } from 'react-bootstrap'
import { getConflictProjectJobs } from './helpers'

const JobConflicts = ({ mergeData, updateMergeData, setPage }) => {
    const { sourceUser, targetUser, isSourceClient, jobsToRemove } = mergeData
    const next = () => {
        if (isSourceClient) {
            setPage('DELETE_SOURCE')
        } else {
            setPage('CONFIRM')
        }
    }
    const back = () => {
        updateMergeData({ jobsToRemove: [] })
        setPage('PREVIEW')
    }
    const selectJob = (job, checked) => {
        if (checked) {
            let newJobs = jobsToRemove.slice()
            const conflictJob = jobsToRemove.find(
                (j) => j.project.id === job.project.id
            )
            if (conflictJob) {
                newJobs = newJobs.filter((j) => j.id !== conflictJob.id)
            }
            updateMergeData({ jobsToRemove: newJobs.concat(job) })
        }
    }
    const conflicts = getConflictProjectJobs(sourceUser.jobs, targetUser.jobs)
    return (
        <div className="job-conflicts">
            <Header as="h4" color="red">
                Data conflicts detected! Please resolve the conflict to proceed.
            </Header>
            <Header as="h4">
                {
                    'Both expert accounts have the job(s) with the same status in the same project(s)'
                }
            </Header>
            <Header as="h4">
                Please select the job to remove
                <Header.Subheader>
                    Click the project title(s) to view the detail in Client app
                </Header.Subheader>
            </Header>
            <List>
                {conflicts.map((conflict) => (
                    <List.Item key={conflict.project.id}>
                        <List.Content>
                            <List.Header
                                as="a"
                                onClick={() =>
                                    window.open(
                                        `${process.env.REACT_APP_CLIENT_BASE_URL}/projects/${conflict.project.id}`,
                                        '__blank'
                                    )
                                }
                            >
                                {conflict.project.title}
                            </List.Header>
                            <List.List>
                                {conflict.jobs.map((job) => (
                                    <List.Item key={job.id}>
                                        <Card fluid className="job-card">
                                            <Card.Content>
                                                <Radio
                                                    checked={jobsToRemove.some(
                                                        (j) => j.id === job.id
                                                    )}
                                                    onChange={(
                                                        e,
                                                        { checked }
                                                    ) =>
                                                        selectJob(job, checked)
                                                    }
                                                />
                                                <div className="card-content">
                                                    <Card.Header
                                                        as="a"
                                                        onClick={() =>
                                                            window.open(
                                                                `${process.env.REACT_APP_BASE_URL}/admin/jobs/${job.id}`,
                                                                '__blank'
                                                            )
                                                        }
                                                    >
                                                        {`${job.user.fullName} (${job.user.email})`}
                                                    </Card.Header>
                                                    <Card.Meta>
                                                        {job.overall_status}
                                                    </Card.Meta>
                                                    {job.meetingAt && (
                                                        <Card.Meta>
                                                            {`Meeting time: ${moment
                                                                .tz(
                                                                    job.meetingAt,
                                                                    job.user
                                                                        .timeZone
                                                                )
                                                                .format(
                                                                    'llll'
                                                                )}`}
                                                        </Card.Meta>
                                                    )}
                                                </div>
                                            </Card.Content>
                                        </Card>{' '}
                                    </List.Item>
                                ))}
                            </List.List>
                        </List.Content>
                    </List.Item>
                ))}
            </List>
            <Modal.Footer>
                <Button content="Back" onClick={back} />
                <Button
                    primary
                    content="Next"
                    disabled={jobsToRemove.length !== conflicts.length}
                    onClick={next}
                />
            </Modal.Footer>
        </div>
    )
}

export default JobConflicts
